import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import * as React from "react";

interface AppConfirmDialogProps {
  isOpen: boolean;
  handleClose: any;
  onSuccess: any;
  onFail: any;
  headerText: string;
  bodyText: string | React.ReactNode;
}

const AppConfirmDialog: React.FunctionComponent<AppConfirmDialogProps> = (
  props,
) => {
  return (
    <Dialog open={props.isOpen} onClose={props.handleClose} fullWidth>
      <DialogTitle>{props.headerText}</DialogTitle>
      <DialogContent>{props.bodyText}</DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          size="small"
          autoFocus
          onClick={props.onFail}
        >
          No
        </Button>
        <Button variant="contained" size="small" onClick={props.onSuccess}>
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AppConfirmDialog;
